import React from "react";

// Isole une rubrique : si son rendu lève une exception (donnée corrompue), elle disparaît seule
// au lieu d'emporter toute la landing.
export default class SectionBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {failed: false};
    }

    static getDerivedStateFromError() {
        return {failed: true};
    }

    componentDidCatch(error) {
        console.error(`Landing : la rubrique « ${this.props.name || "?"} » n'a pas pu s'afficher —`, error.message);
    }

    render() {
        return this.state.failed ? null : this.props.children;
    }
}
